import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { isUndefined } from 'lodash'

import styles from './ButtonAddToCart.module.css'

export default class ButtonAddToCart extends React.PureComponent {
    static propTypes = {
        //children: PropTypes.node.isRequired,
        isCompleted: PropTypes.bool,
        isDisabled: PropTypes.bool,
        glyph: PropTypes.oneOf(['plus']),
        glitch: PropTypes.bool,
        gtmTag: PropTypes.string,
        isWide: PropTypes.bool,

        onClick: PropTypes.func.isRequired,
    }

    handleClick = (event) => {
        /*if (this.gtmTagRef) {
            this.gtmTagRef.click()
        }*/
        if (!this.props.isDisabled)
            this.props.onClick(event)
    }

    renderGtmTag() {
        return !isUndefined(this.props.gtmTag) ? (
            <div className={classNames(this.props.gtmTag)} ref={c => (this.gtmTagRef = c)} />
        ) : null
    }

    render() {
        const classNameBase = classNames(styles.base, {
            [styles[`base__${this.props.glyph}`]]: this.props.glyph,
            [styles.isDisabled]: this.props.isDisabled,
            [styles.isWide]: this.props.isWide,
            [styles.glitch]: this.props.glitch,
        })

        let titleAdd
        this.props.isDisabled ? titleAdd = 'Невозможно добавить в корзину' : titleAdd = 'Добавить в корзину'

        return (
            <React.Fragment>
                {this.renderGtmTag()}
                <div className={classNameBase} title={titleAdd} onClick={this.handleClick}></div>
            </React.Fragment>
        )
    }
}
